import type { Step } from 'react-joyride';

export const PROJECT_TOUR_STEPS: Step[] = [
  {
    target: 'body',
    content: "A project is a collection of stories. Each story is one AR scene at a location. You'll add stories here, edit them in the editor, then publish when you're ready. Let's walk through the main actions.",
    title: 'Projects & Stories',
    placement: 'center',
    disableBeacon: true,
    disableScrolling: true
  },
  {
    target: '[data-tour="project-title-and-status"]',
    content: 'Your project name and status (draft, live, pending, etc.) are shown here. Click the project title or hero image to edit details.',
    title: 'Project title & status',
    disableBeacon: true
  },
  {
    target: '[data-tour="project-share-actions"]',
    content: 'Before publishing your project be sure to add pictures and info on the Edit Project page.',
    title: 'Share & Publish',
    disableBeacon: true
  },
  {
    target: '[data-tour="project-stories-section"]',
    content: 'Each story is one AR scene. Drag to reorder, click to edit.',
    title: 'Stories',
    disableBeacon: true
  },
  {
    target: '[data-tour="new-story"]',
    content: 'Add a new story to this project to start building your experience.',
    title: 'Add a Story',
    disableBeacon: true
  }
];
